import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

/**
 * Form Props
 */
@Component
class Props extends Mixins() {
    /**
     * Elements of the components
     */
    @Prop() elements!: object;

    /**
     * Col Size
     */
    @Prop({ default: 12 }) colSize!: number | string;

    /**
     * Value of the field (Equal to _element.value_)
     */
    @Prop() value!: any;

    /**
     * Add CSS Class to each component
     */
    @Prop() componentClass!: string;
}

export default Props;
